<template>
  <div class="permissionEdit">
    <div class="permissionEdit_title">
      <img class="iconfont icon-wenjianjia-gongkai" src="~@/assets/img/wenjianjia.png">
      <div class="permissionEdit_title_name">{{ nodeData.name }}</div>
      <el-select v-model="status" placeholder="不限" clearable class="permissionEdit_title_status" @change="()=>search()">
        <el-option
          v-for="item in statusOpts"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div v-if="status==='public'" class="permissionEdit_content_public">
      公开可见
    </div>
    <div v-else class="permissionEdit_content_private">
      <el-tree 
        ref="tree"
        class="classify-tree"
        :data="treeData" 
        :props="{
          children: 'children',
          label: 'name'
        }"
        :node-key="nodeKey"
        :highlight-current="true"
        :default-expanded-keys="computed_expandedKeysArr"
        :expand-on-click-node="false"
        :indent="16"
        @node-click="nodeClick"
      >
        <div slot-scope="{ data }" class="custom-tree-node">
          <span class="custom-tree-node-title" :title="node.label">{{ data.name }}</span>
        </div>
      </el-tree>

    </div>
  </div>
</template>
<script>
export default {
  name: 'PermissionEdit',
  components: { },
  props: {
    nodeData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      statusOpts: [{ label: '公开可见', value: 'public' }, { label: '限制查看', value: 'private' }],
      status: 'public'
    }
  },
  computed: {
    
  },
  created() {
  },

  methods: {
   
  }
}
</script>
<style lang='less'>
.permissionEdit {
  .permissionEdit_title {
    .icon-wenjianjia-gongkai {
      width: 16px;
      height: 16px;
      margin-top: 8px;
      float: left;
    }
    .permissionEdit_title_name {
      height: 32px;
      line-height: 32px;
      margin-left: 5px;
      float: left;
    }
    .permissionEdit_title_status {
      float: right;
      width: 160px;
    }
    &::after{
      display: block;
      content: '';
      clear: both;
    }
  }
  .permissionEdit_content_public {
    color: #50505A;
    text-align: center;
    font-size: 24px;
    height: 420px;
    line-height: 420px;
    border: 1px solid #E6E6E6;
    background: #F7F9FA;
    margin-top: 10px;
  }
  .permissionEdit_content_private {
    height: 420px;
    border: 1px solid #E6E6E6;
    background: #F7F9FA;
    margin-top: 10px;
  }
}
</style>
